import React, { useState } from "react";
import { useForm } from "react-hook-form";

import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import {
  uploadFileToDocument,
  updateDocumentCase,
  createDocument
} from "services/file_service";

import "css/main.css";
import "css/style.css";

import { reportProblem } from "services/case_service";
import Topnav from "components/Topnav";


function ReportProblem() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [fileName, setFileName] = useState("");
  const [document, setDocument] = useState(null);

  const { register, handleSubmit } = useForm();

  const submitRecord = async (data) => {
    const caseData = await reportProblem({ ...data });

    if (document) {
      await updateDocumentCase(document.id, caseData.id);
    }
    
    navigate("/lista-casos");
  };

  const changeHandler = async (event) => {
    const doc = await createDocument(null, event.target.files[0].name, null);

    await uploadFileToDocument(doc.id, event.target.files[0]);
    
    setDocument(doc);
    
    setFileName(event.target.files[0].name);
  };

  return (
    <div className="geral">
      <Topnav></Topnav>
      <div className="conteudo">
        <section className="section">
          <nav className="breadcrumb" aria-label="breadcrumbs">
            <ul>
              <li>
                <Link to={"/lista-casos"}>{t("help_center")}</Link>
              </li>
              {" "}
              <li className="is-active">
                <Link>{t("new_ticket")}</Link>
              </li>
            </ul>
          </nav>

          <div className="hero is-footsolution">
            <div className="columns">
              <div className="column">
                <h1 className="title is-3">{t("new_ticket")}</h1>
              </div>
              <div className="column">
                <div className="buttons is-end">
                  <Link to={"/lista-casos"}>
                    <button className="button btn1">{t("close")}</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <form onSubmit={handleSubmit((data) => submitRecord(data))}>
            <div className="list is-footsolution">
              <div className="columns">
                <div className="column is-8">
                  <div className="box-footsolution">
                    <div className="body-form control">
                      <div className="subject-message">
                        <h3 className="subtitle is-footsolution">{t("subject")}</h3>
                        <textarea
                          {...register("body", {
                            required: true,
                            minLength: 10,
                          })}
                          className="textarea is-footsolution"
                          placeholder={t("subject_placeholder")}
                          rows="1"
                        ></textarea>
                      </div>

                      <div className="body-messagem">
                        <h3 className="subtitle is-footsolution">
                          {t("description")}
                        </h3>
                        <textarea
                          {...register("description", {
                            required: true,
                            minLength: 20,
                          })}
                          className="textarea is-footsolution"
                          placeholder={t("body_placeholder")}
                          rows="8"
                        ></textarea>
                      </div>

                      <div className="anexos">
                        <ul>
                          {document && (
                          <li>
                              <span className="icon">
                                <i className="fa fa-paperclip"></i>
                              </span>{" "}
                              {fileName}
                          </li>
                          )}
                        </ul>
                      </div>

                      <div className="buttons is-right">
                      
                        <button className="button is-footsolution" >
                          <input
                            className="file-input"
                            type="file"
                            name="resume"
                            onChange={(event) =>
                              changeHandler(
                                event
                              )
                            }
                          />
                          <span className="icon" style={{"margin": 0}}>
                            <i className="fa fa-paperclip"></i>
                          </span>
                        </button>
                        <button className="button is-link is-footsolution">
                          {t("send")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="column">
                  <div className="box-footsolution extra">
                    <h2 className="title is-5">{t("article_section_info")}</h2>
                    <div className="container-counter">
                      <p>{t("check_articles_further_info")}</p>
                    </div>
                    <Link to={"/artigos"}>{t("view_articles")}</Link>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </div>
  );
}

export default ReportProblem;
